import React, { useEffect } from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import { useForm } from "react-hook-form";
import MyButton from '@components/MyButton';
import { useNavigate, useParams } from 'react-router-dom';
import useEmployee from '@hooks/useEmployee';
import { Employee } from '@models/Models';


const EditEmployee = () => {
    const navi = useNavigate();
    const { employeeId } = useParams();
    const { updateEmployee, getEmployeeById } = useEmployee();
    const [employee, setEmployee] = React.useState<Employee | null>(null);
    const { register, getValues, setValue } = useForm({
        defaultValues: {
            firstName: employee?.firstName,
            lastName: employee?.lastName,
        }
    });

    useEffect(() => {
        if(employee){
            setValue("firstName", employee.firstName);
            setValue("lastName", employee.lastName);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [employee])

    useEffect(() => {
        if(employeeId){
            employeeGetter();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [employeeId]);

    const employeeGetter = async () => {
        const employee = await getEmployeeById(employeeId as string)

        setEmployee(employee.data);
    }

    const handleSubmit = async () => {
        const { firstName, lastName } = getValues();

        const editedEmployee: Partial<Employee> = {
            firstName,
            lastName,
        };

        const updateEmployeeResult = await updateEmployee(employeeId as string, editedEmployee);

        if(!updateEmployeeResult.success) {
            alert("Fehler beim Hinzufügen des Mitarbeiters.");
            return;
        };
        navi("/mitarbeiter");
    };

    return (
        <Container className='myCont'>
            <h1>Mitarbeiter hinzufügen</h1>
            <Row className='my-3'>
                <Col>
                    <Form.Group>
                        <Form.Label>Vorname</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Vorname"
                            {...register("firstName")}
                        />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.Label>Nachname</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Nachname"
                            {...register("lastName")}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col className='d-flex justify-content-end gap-3'>
                    <MyButton
                        title='Zurück'
                        disabled={false}
                        isSecundary={true}
                        onClick={() => navi("/")}
                    />
                    <MyButton
                        title='Weiter'
                        disabled={false}
                        isSecundary={false}
                        onClick={handleSubmit}
                    />
                </Col>
            </Row>
        </Container>
    )
}

export default EditEmployee